<template>
  <p class="whitespace-pre-line text-sm text-red-400 error">{{ translated }}</p>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps<{
  error: string
}>()

const translated = computed(() => {
  return t(`errors.${props.error}`)
})

</script>